import { render, staticRenderFns } from "./water-immersion.vue?vue&type=template&id=7da37067&scoped=true"
import script from "./water-immersion.vue?vue&type=script&lang=js"
export * from "./water-immersion.vue?vue&type=script&lang=js"
import style0 from "./water-immersion.vue?vue&type=style&index=0&id=7da37067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da37067",
  null
  
)

export default component.exports